import React from "react";
import maryRd from "../../static/images/profile/maryRd.png";
import mattRd from "../../static/images/profile/mattRd.png";
import laineRd from "../../static/images/profile/laineRd.png";
import tiffanyRd from "../../static/images/profile/tiffanyRd.jpg";
import bestTimeForProtein from "../../static/images/profile/best-time-for-protein-profile.png";
import howMuchProtein from "../../static/images/profile/how-much-protein-profile.jpeg";
import proteinLoseWeight from "../../static/images/profile/protein-lose-weight-profile.jpeg";
import increaseProteinIntake from "../../static/images/profile/increase-protein-intake-profile.jpeg";

export const dietitianData = {
  Matt: {
    name: "Matt Mazzino",
    image: mattRd,
    bio:
      "Matt Mazzino channelled his passion for fitness into a degree from the University of Cincinnati" +
      " in dietetics which led him to become a dietitian. In addition to working with Gainful," +
      " he has served as a dietitian in various hospitals as well as in outpatient counseling. " +
      "Matt believes that every body is unique and may benefit from different dietary approaches.",
    funFacts: [
      <div>
        🏋️‍♀️ 💪
        <br />
        Competes in bodybuilding and powerlifting
      </div>,
      <div>
        ☃️ 🥶
        <br />
        Loves cold weather
      </div>,
      <div>
        🍬 🍦
        <br />
        Has a sweet tooth—ice cream is his weakness
      </div>,
      <div>
        🤿 🏖
        <br />
        Enjoys scuba diving when he’s on vacation
      </div>,
    ],
  },
  Mary: {
    name: "Mary Albus",
    image: maryRd,
    bio:
      "Mary Albus is a Registered Dietitian who works in both community and clinical settings to help" +
      " people reach their unique health and fitness goals. She finds passion in creating a" +
      " personalized approach for her clients, as it allows them to take pride in setting (and crushing)" +
      " realistic goals for themselves.",
    funFacts: [
      <div>
        ⚕️ 🎭 <br />
        Studied nutrition and theatre at Penn State
      </div>,
      <div>
        💃 🚴
        <br />
        Has instructed both Zumba and indoor cycling classes
      </div>,
      <div>
        🐶
        <br />
        Volunteers with a local rescue dog non-profit on the weekends
      </div>,
      <div>
        🍕🍕
        <br />
        Averages 2 slices of pizza per week
      </div>,
    ],
  },
  Laine: {
    name: "Laine Strobel",
    image: laineRd,
    bio:
      "Laine Strobel is a graduate of the University of Alabama's Coordinated Program in Dietetics " +
      "and currently resides in New York City where she specializes in integrative and functional nutrition." +
      " She’s a nutritional counselor for general wellness, chronic disease prevention and treatment," +
      " and works with performers and actors in New York and across the US on performance nutrition." +
      " She’s also a dietitian with Mount Sinai's Department of Neurology.",
    funFacts: [
      <div>
        💃 🍎
        <br />
        Was a double major in dance and nutrition in college
      </div>,
      <div>
        🧙‍♂️ ⚡️
        <br />
        Claims to be THE biggest Harry Potter fan ever
      </div>,
      <div>
        🍦 🍟
        <br />
        Favorite foods are Reese\'s ice cream and french fries
      </div>,
      <div>
        🏌️‍♀️
        <br />
        She’s 5'10", but horrible at all sports except for golf
      </div>,
    ],
  },
  Tiffany: {
    name: "Tiffany Ma",
    image: tiffanyRd,
    bio:
      "Tiffany Ma is a Registered Dietitian with a Bachelor’s Degree in Dietetics from the" +
      "State University of New York at Oneonta. Her interest in nutrition was first sparked when she ran high" +
      " school cross country. Tiffany is fascinated by the link between nutrition and performance and applies" +
      " the same concepts to her everyday life as a fitness enthusiast and former nationally-ranked powerlifter.",
    funFacts: [
      <div>
        🥦
        <br />
        Has been a vegetarian for nearly 15 years
      </div>,
      <div>
        🛫 🌎
        <br />
        Once quit her job to solo travel across South America
      </div>,
      <div>
        🕵️
        <br />
        Is addicted to true crime podcasts and documentaries
      </div>,
      <div>
        🏋️‍♀️ 🤕
        <br />
        Once dropped 275 lbs on her foot when deadlifting in the gym (ouch!)
      </div>,
    ],
  },
};

export const dietitianFaqs = [
  {
    title: "What is the right macronutrient breakdown for me?",
    body:
      "The right macronutrient breakdown depends on many individual factors," +
      " and you'll need to get in touch with your Registered Dietitian to discuss your needs. " +
      "In general, aim to stay around the range of 45-60% of calories from carbohydrates, 15-30% from fat, " +
      "and 10-25% from protein. For a breakdown specific to you, message your RD above.",
  },
  {
    title: "Which foods should I eat?",
    body:
      "Ideally, the majority of your diet should consist of nutrient-dense, " +
      "whole foods such as fruits, vegetables, grains, lean protein sources, " +
      "and dairy or dairy alternatives. Fresh, frozen, and canned fruits and veggies are all great!" +
      " Some lean protein sources include your Gainful blend, eggs, tofu, beans, chicken, turkey," +
      " and lean cuts of red meat. For grains, choose mostly whole grains such as brown rice, wheat " +
      "pasta or bread, whole grain cereals, popcorn, oats, and quinoa. For dairy, choose 1% or " +
      "fat free versions of milk, cheese, and yogurt or unsweetened dairy alternatives when able.",
  },
  {
    title: "How do I gain weight?",
    body:
      "Gaining weight will come down to being in a calorie surplus." +
      " This means that you are consuming more calories over time than your body requires. " +
      "Changes that you can make in your diet to increase calorie intake and promote weight gain " +
      "could be to increase meal size or frequency, add in snacks between meals, or use higher calorie " +
      "dense foods. Gradual changes to your diet habits are most beneficial as they will promote slow " +
      "and healthy weight gain. If you want more of your weight gain to be muscle, include resistance training" +
      " regularly each week.",
  },
  {
    title: "What are some ways to break through a weight loss plateau?",
    body:
      "Weight loss plateaus are common, and usually happen after someone has lost a significant amount " +
      "of weight. In order to continue weight loss and get over the plateau, you need to further reduce your" +
      " overall calorie balance. This can come through changes made primarily with your eating habits or " +
      "activity level. You can modify your normal routine in ways such as including lower calorie/healthier" +
      " food choices, using smaller portions, having less snacks, or including more exercise or activity. " +
      "Reducing calorie intake or output by just a couple hundred is all that " +
      "is needed to keep going with your weight loss.",
  },
  {
    title: "Should I drink protein powder on days I don't workout?",
    body:
      "You can choose to use your protein powder on days you don’t exercise if you’d like," +
      " or simply just consume it on workout days. Protein needs are increased on days that you are working out," +
      " however, protein itself is still an important nutrient to consume enough on other days as well." +
      " If you are already consuming enough protein through food on rest days, then you can decide to only" +
      " use your protein powder on days you workout. Otherwise, feel free to include it in your everyday diet" +
      " as a tasty, healthy and high protein option.",
  },
  {
    title: "What should I mix my protein powder with?",
    body:
      "We recommend mixing your protein blend with ~8 oz of cold milk or plant-based milk " +
      "and a Flavor Boost of choice. You can also mix it with water, though milk will produce a more flavorful " +
      "and creamy shake. Additionally, it can be added to smoothies along with fruits, veggies, " +
      "dairy/dairy alternatives, and more. Here are some great post-workout " +
      "smoothie recipes: https://www.gainful.com/blog/post-workout-smoothies/",
  },
];

export const dietitianBlogPostData = [
  {
    image: bestTimeForProtein,
    title: "When is the best time to drink a protein shake?",
    date: "08/25/20",
    category: "Protein 101",
    url: "https://www.gainful.com/blog/when-is-the-best-time-to-drink-a-protein-shake/",
  },
  {
    image: howMuchProtein,
    title: "How much protein to build muscle? Ask an RD",
    date: "09/29/20",
    category: "Protein 101",
    url: "https://www.gainful.com/blog/how-much-protein-to-build-muscle/",
  },
  {
    image: proteinLoseWeight,
    title: "Does protein help you lose weight?",
    date: "12/02/20",
    category: "Protein 101",
    url: "https://www.gainful.com/blog/does-protein-help-you-lose-weight/",
  },
  {
    image: increaseProteinIntake,
    title: "5 Easy Ways to Increase Your Protein Intake",
    date: "04/29/21",
    category: "Protein 101",
    url: "https://www.gainful.com/blog/how-to-increase-protein-intake/",
  },
];
